export default __webpack_public_path__ + "static/media/auction-coin-stack.0b730047.svg";